import http from "@/http-common";
import './security';

class LocationService {
  getAll() {
    return http.get("/location");
  }

  getAllTypes() {
    return http.get("/location/type");
  }

  getLocationTypeFromAlias(alias){
    return http.get(`/location/type/alias?alias=${alias}`);
  }

  get(id) {    
    return http.get(`/location/id/${id}`);
  }

  create(data) {
    return http.post("/location", data);
  }

  update(data) {   
    return http.put(`/location/id/${data._id}`, data);
  }

  findByAlias(alias) {
    if (!alias) {
      return http.get("/location");
    } else {
      return http.get(`/location/alias?alias=${alias}`);
    }
  }

  delete(id) {
    return http.delete(`/location/id/${id}`);
  }

  deleteAll() {
    return http.delete(`/location`,data);
  }

  nodeSensorCount(id) {
    return http.get(`/location/count/id/${id}`)
  }

}

export default new LocationService();
